import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { _HttpClient } from '@delon/theme';

@Component({
  selector: 'app-accountant-select',
  templateUrl: './accountant-select.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AccountantSelectComponent),
      multi: true
    }
  ]
})
export class AccountantSelectComponent implements OnInit {
  @Input() selected: any;
  accountant: any = [];
  value: any[] = [];
  searching: boolean = false;
  @Output() readonly selectedChange = new EventEmitter();
  constructor(private http: _HttpClient,) {
  }

  ngOnInit(): void {
    this.getAccountant()
  }

  getAccountant(){
    this.searching = true;
    this.http.get('api/reporting/partners/getAccountant').subscribe({
      next: (res: any) => {
        this.accountant = res;
        this.searching = false;
      }
    });
  }

  onChange($event: any[]): void{
    this.selected = $event;
    this.selectedChange.emit(this.selected);
  }
}

// getUrl(searchValue: string): string {
//   let filter = ``;
//   // if (searchValue) {
//   //   filter = this.odata.getSearchFilterString(searchValue, ['CustomerName', 'DocCode']);
//   // }
//   let url = `api/reporting/partners/getAccountant`;
//   //if (filter) url += `&$filter=${filter}`;
//   return url;
// }
